import React, { useState, useEffect } from 'react';

const ErrorBoundary = ({ children }) => {
        const [hasError, setHasError] = useState(false);
        const [errorInfo, setErrorInfo] = useState(null);

        const resetError = () => {
                setHasError(false);
                setErrorInfo(null);
        };


        useEffect(() => {
                const handleError = (error, info) => {
                        setHasError(true);
                        setErrorInfo(info);
                        console.error('Error caught in ErrorBoundary:', error);
                };

                const handleUncaughtError = (event) => {
                        handleError(event.error, { componentStack: 'Uncaught error' });
                };

                // Register global error handler
                window.addEventListener('error', handleUncaughtError);
                return () => {
                        window.removeEventListener('error', handleUncaughtError);
                };
        }, []);

        if (hasError) {
                return (
                        <div style={{ padding: 20, backgroundColor: '#ffecec', color: '#b30000' }}>
                                <h3>❌ Something went wrong</h3>
                                {errorInfo?.componentStack && <pre>{errorInfo.componentStack}</pre>}
                                <button
                                        onClick={resetError}
                                        style={{ marginTop: '1rem' }}
                                >
                                        Try Again
                                </button>
                        </div>
                );
        }

        return children;
};

export default ErrorBoundary;
